import { STOREMODULE_ENDPOINT_MAP } from '@/assets/js/config/server'

// import http from '@/$plugins/http'

import base from '../base'
import IS from '../base/is'
import ENTITY from '../base/entity'

export default {
  namespaced: true,
  state: base.createState(IS.state, ENTITY.state, { /* define custom state-properties */ }),
  getters: base.createGetters(IS.getters, ENTITY.getters, { /* define custom getters */ }),
  mutations: base.createMutations(IS.mutations, ENTITY.mutations, { /* define custom mutations */ }),
  actions: base.createEntityActions(STOREMODULE_ENDPOINT_MAP.userservices, IS.actions, ENTITY.actions, { /* define custom actions */ })
}
